import { isStudentResponseDTO, StudentResponseApi } from "../Student/Student";

export interface GroupStudentResponseApi {
  student: StudentResponseApi;
  groupStudentId: string;
}

export let isGroupStudentResponseDTO = (
  variable: unknown
): variable is GroupStudentResponseApi => {
  return (
    variable !== undefined &&
    variable !== null &&
    typeof variable === "object" &&
    "groupStudentId" in variable &&
    typeof variable.groupStudentId === "string" &&
    "student" in variable &&
    isStudentResponseDTO(variable.student)
  );
};
